import { __assign, __rest } from "tslib";
import React from 'react';
import { Box, FormField, Input, InputWithLabel, Text, } from '@wix/design-system';
import { withProviders } from './PasswordInput.container';
import { withPasswordStrength, } from './hoc/WithPasswordStrength';
import { withPasswordVisibility, } from './hoc/WithPasswordVisibility';
import s from './PasswordInput.scss';
import classNames from 'classnames';
var PasswordInputCore = function (props, ref) {
    var _a;
    var _b;
    if (props.inputWithLabel) {
        return (React.createElement(Box, { direction: "vertical", width: props.width, marginLeft: props.marginLeft, marginRight: props.marginRight, paddingBottom: !props.showStrength ? 2 : 0, minWidth: props.minWidth, className: s.passwordInputContainer },
            React.createElement(InputWithLabel, __assign({}, props, { className: classNames(s.passwordInputContainer, (_a = {},
                    _a[s.bottomLineInput] = props.border === 'bottomLine',
                    _a)), status: props === null || props === void 0 ? void 0 : props.status, statusMessage: props === null || props === void 0 ? void 0 : props.statusMessage, label: (React.createElement(Text, { id: s.inputLabel }, props === null || props === void 0 ? void 0 : props.label)), ref: ref }))));
    }
    if (props.inlineErrorMessage) {
        var status_1 = props.status, statusMessage = props.statusMessage, rest = __rest(props, ["status", "statusMessage"]);
        return (React.createElement(Box, { paddingBottom: !props.showStrength ? 2 : 0 },
            React.createElement(FormField, __assign({}, props.formFieldProps, { status: status_1, statusMessage: statusMessage }),
                React.createElement(Input, __assign({}, rest, { ref: ref })))));
    }
    return (React.createElement(Box, { paddingBottom: !props.showStrength ? 2 : 0 },
        React.createElement(FormField, { label: (_b = props === null || props === void 0 ? void 0 : props.formFieldProps) === null || _b === void 0 ? void 0 : _b.label },
            React.createElement(Input, __assign({}, props, { ref: ref })))));
};
export var PasswordInput = withProviders(withPasswordVisibility(withPasswordStrength(React.forwardRef(PasswordInputCore))));
PasswordInput.displayName = 'PasswordInput';
//# sourceMappingURL=PasswordInput.js.map